import * as log from './log';

export const LANDOWNER_INSURANCE_SENTRY_CODES = {
  createSubscriptionFailed: 'landowner-insurance-create-subscription-failed',
  paymentFailed: 'landowner-insurance-payment-failed',
};

export const LANDOWNER_INSURANCE_ERROR_MESSAGE_IDS = {
  enrollmentSupport: 'LandownerInsurance.enrollmentSupportError',
  paymentSupport: 'LandownerInsurance.paymentSupportError',
};

export const USER_FACING_STRIPE_CODES = new Set(['expired_card']);

export const parseInsuranceApiError = error => {
  if (!error?.message) {
    return null;
  }

  try {
    const parsed = JSON.parse(error.message);

    if (parsed && typeof parsed === 'object') {
      return {
        source: parsed.source ?? null,
        message: parsed.message ?? null,
        code: parsed.code ?? null,
      };
    }
  } catch {
    // error.message is not JSON from the insurance API
  }

  return null;
};

export const logInsuranceEnrollmentError = ({ error, code, extra = {} }) => {
  const apiError = parseInsuranceApiError(error);
  const capturedError =
    error instanceof Error ? error : new Error(error?.message || 'Unknown error');

  log.error(capturedError, code, {
    ...extra,
    ...(apiError ? { insuranceApiError: apiError } : {}),
  });
};

export const getCreateSubscriptionUserMessageId = () =>
  LANDOWNER_INSURANCE_ERROR_MESSAGE_IDS.enrollmentSupport;

export const getPaymentUserMessage = stripeError => {
  if (!stripeError) {
    return null;
  }

  const isUserFixableError =
    stripeError.type === 'card_error' ||
    stripeError.type === 'validation_error' ||
    USER_FACING_STRIPE_CODES.has(stripeError.code);

  return isUserFixableError ? stripeError.message : null;
};
